"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var uniqueId_1 = tslib_1.__importDefault(require("lodash/uniqueId"));
var react_1 = tslib_1.__importDefault(require("react"));
var StyledTooltip_1 = require("./StyledTooltip");
var TooltipInner_1 = tslib_1.__importDefault(require("./TooltipInner"));
var utils_1 = require("./utils");
var ResponsiveContext_1 = require("../../contexts/ResponsiveContext");
var Modal_1 = require("../Modal");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.openOnHover, openOnHover = _b === void 0 ? false : _b, _c = _a.openOnClick, openOnClick = _c === void 0 ? false : _c, _d = _a.openOnFocus, openOnFocus = _d === void 0 ? false : _d, ariaLabel = _a.ariaLabel, maxWidth = _a.maxWidth, _e = _a.modalOnMobile, modalOnMobile = _e === void 0 ? false : _e;
    var _f = react_1.default.useState(false), isClicked = _f[0], handleClick = _f[1];
    var _g = react_1.default.useState(false), isFocused = _g[0], handleFocus = _g[1];
    var _h = react_1.default.useState(false), isHover = _h[0], handleHover = _h[1];
    var _j = react_1.default.useState({ top: 0, left: 0, width: 0, height: 0 }), rect = _j[0], setRect = _j[1];
    var wrapperRef = react_1.default.useRef(null);
    var updatePosition = function () {
        if (wrapperRef.current) {
            setRect(utils_1.getElementPosition(wrapperRef.current));
        }
    };
    react_1.default.useEffect(function () {
        updatePosition();
    }, [isClicked, isFocused, isHover]);
    react_1.default.useEffect(function () {
        window.addEventListener('resize', debounce_1.default(updatePosition, 100));
        return function () { return window.removeEventListener('resize', updatePosition); };
    }, []);
    var handleClose = function () {
        handleClick(false);
    };
    var wrapperProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (openOnHover ? { onMouseEnter: function () { return handleHover(true); }, onMouseLeave: function () { return handleHover(false); } } : {})), (openOnClick
        ? {
            onClick: function (e) {
                handleClick(!isClicked);
                if (isFocused) {
                    handleFocus(false);
                }
                if (isHover) {
                    handleHover(false);
                }
                e.preventDefault();
            }
        }
        : {})), (openOnFocus ? { onFocus: function () { return handleFocus(true); }, onBlur: function () { return handleFocus(false); } } : {}));
    var isOpen = isClicked || isFocused || isHover;
    var tooltipId = uniqueId_1.default('tooltip');
    var renderTooltip = function () { return (react_1.default.createElement(TooltipInner_1.default, { content: content, isOpen: isOpen, onClose: handleClose, targetRect: rect, id: tooltipId, maxWidth: maxWidth })); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledTooltip_1.StyledTargetWrapper, tslib_1.__assign({ ref: wrapperRef }, wrapperProps, { tabIndex: 0, role: "button", "data-testid": "tooltip-wrapper", "aria-label": ariaLabel, "aria-describedby": tooltipId }), children),
        modalOnMobile ? (react_1.default.createElement(ResponsiveContext_1.ResponsiveContext.Consumer, null, function (size) {
            return size === 'xs' ? (react_1.default.createElement(Modal_1.Modal, { isOpen: isClicked, onClose: handleClose, title: ariaLabel }, content)) : (renderTooltip());
        })) : (renderTooltip())));
};
/** @component */
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map